import apiClient from '../../../services/apiClient';

const compactParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );

const unwrapList = (payload) => {
  let current = payload;

  for (let index = 0; index < 4; index += 1) {
    if (Array.isArray(current)) {
      return current;
    }

    if (!current || typeof current !== 'object') {
      return [];
    }

    if (Array.isArray(current.results)) {
      return current.results;
    }

    if (Array.isArray(current.data)) {
      return current.data;
    }

    if (current.data && typeof current.data === 'object') {
      current = current.data;
      continue;
    }

    break;
  }

  return [];
};

export const academicApi = {
  getAcademicYears: async (schoolId, params = {}) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/academics/academic-years/`,
      {
        params: compactParams({
          status: params.status,
          is_current: params.isCurrent,
        }),
      },
    );

    return unwrapList(response.data);
  },

  getClassLevels: async (
    schoolId,
    { academicYearId, status } = {},
  ) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/academics/class-levels/`,
      {
        params: compactParams({
          academic_year_id: academicYearId,
          status,
        }),
      },
    );

    return unwrapList(response.data);
  },

  getSections: async (
    schoolId,
    { academicYearId, classLevelId, status } = {},
  ) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/academics/sections/`,
      {
        params: compactParams({
          academic_year_id: academicYearId,
          class_level_id: classLevelId,
          status,
        }),
      },
    );

    return unwrapList(response.data);
  },

  getSubjects: async (
    schoolId,
    { academicYearId, classLevelId, status } = {},
  ) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/academics/subjects/`,
      {
        params: compactParams({
          academic_year_id: academicYearId,
          class_level_id: classLevelId,
          status,
        }),
      },
    );

    return unwrapList(response.data);
  },
};

export default academicApi;
